// import Main from "../components/layout/Main";
// import Header from "../components/layout/Header";
import { useNavigate } from "react-router-dom";
// import {
//   ArrowLeftOutlined,
//   BarChartOutlined,
//   DashboardTwoTone,
//   DashboardOutlined,
//   BranchesOutlined,
// } from "@ant-design/icons";
// import { useEffect } from "react";
// import { SearchOutlined } from "@ant-design/icons";
// import {
//   Button,
//   Input,
//   Space,
//   Table,
//   Badge,
//   Modal,
//   Checkbox,
//   Tag,
//   Spin,
// } from "antd";
// import React, { useRef, useState } from "react";
// import Highlighter from "react-highlight-words";
// import { get, post } from "../Libraries/Ajax/HttpService";
// import Img1 from "../assets/images/img1.png";
// import Meter from "../assets/images/meter.png";
// import Tank from "../assets/images/tank.png";
// import GPWell from "../assets/images/gpwell.png";
// import WaterPlants from "../assets/images/water-plants.png";
// import WaterMeter from "../assets/images/water-meter.png";
// import LeftArrow from "../assets/images/left-arrow.svg";
// import Reservoir from "../assets/images/reservoir.svg";
// import Pump from "../assets/images/pump.svg";
// import round from "../assets/images/round.svg";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
import back from "../assets/images/back.svg";

// const Schematics = () => {
//   const [usage, setUsage] = useState("");
//   const [unit, setUnit] = useState("");
//   const [meterid, setMeterid] = useState("");
//   const [status, setStatus] = useState("");
//   const [accountname, setAccountname] = useState("");
//   const [name, setName] = useState("");
//   const [address, setAddress] = useState("");
//   const [addressone, setAddressone] = useState("");
//   const [addresstwo, setAddresstwo] = useState("");
//   const [addressthree, setAddressthree] = useState("");
//   const [addressfour, setAddressfour] = useState("");
//   const [meterids, setMeterids] = useState("");
//   const [statuss, setStatuss] = useState("");
//   const [accountnames, setAccountnames] = useState("");
//   const [addresss, setAddresss] = useState("");
//   const [addressones, setAddressones] = useState("");
//   const [addresstwos, setAddresstwos] = useState("");
//   const [addressthrees, setAddressthrees] = useState("");
//   const [addressfours, setAddressfours] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [open, setOpen] = useState(false);
//   const [opens, setOpens] = useState(false);
//   const [openss, setOpenss] = useState(false);
//   const [res, setRes] = useState([]);
//   const [resTP, setResTP] = useState([]);
//   const [nerge, setNerge] = useState([null]);
//   const [weekly, setWeekly] = useState(false);
//   const [regNo, setregNo] = useState("");
//   const navigate = useNavigate();
//   const arryDatass = [];
//   const onRedirection = (event) => {
//     navigate(-1);
//   };
//    const modalclickss = async (event) => {
//     try {
//       setLoading(true);
//       setOpenss(true);

//       const selectedId = event.currentTarget.id;
//       setName(selectedId);

//       console.log("selectedId::",selectedId);

//       const response = await get(
//         `apis/schematic_meter?total_flow=${selectedId}`
//       );
//       const resData = response?.data?.data;
//       setResTP(response);

//       if (!resData) {
//         console.error("Invalid response structure:", response);
//         return;
//       }

//       const meters = resData?.data_meters || [];
//       const meter0 = meters[0] || {};
//       const meter1 = meters[1] || {};

//       setAccountname(meter0.overided_name);
//       setUsage(resData.total_sum);
//       setUnit(resData.unit);
//       setMeterid(meter0.meter_id);
//       setStatus(meter0.status);

//       setAddress(meter0.location_address_line1);
//       setAddressone(meter0.location_address_line2);
//       setAddresstwo(meter0.location_city);
//       setAddressthree(meter0.location_state);
//       setAddressfour(meter0.location_zip);

//       setAccountnames(meter1.overided_name);
//       setMeterids(meter1.meter_id);
//       setStatuss(meter1.status);

//       setAddresss(meter1.location_address_line1);
//       setAddressones(meter1.location_address_line2);
//       setAddresstwos(meter1.location_city);
//       setAddressthrees(meter1.location_state);
//       setAddressfours(meter1.location_zip);

//       const flowArray = resData?.meter_flow || [];
//       const arryDatass = flowArray.map((x) => ({
//         name: x.option || "",
//         Flow: x.flow || 0,
//       }));

//       setNerge(arryDatass);
//     } catch (error) {
//       console.error("Error fetching schematic_meter data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const weeklyChange = (e) => {
//     var id = e.target.id;
//     setWeekly(e.target.checked);
//     var user = JSON.parse(localStorage.getItem("MCData"));
//     var userid = user?.userid;
//     console.log("print = ", regNo);
//     if (regNo == null) {
//       setregNo("");
//     }
//     post(
//       `apis/notification_meters_update?user_id=${userid}&meter_id=${id}&account_name=${accountname}&status=${e.target.checked}&register_number=${regNo}`
//     ).then((response) => {

//     });
//   };
//   const modalclicks = async (event) => {
//     try {
//       console.log("!!!!!!!!!!!");

//       setLoading(true);
//       setOpens(true);

//       const flowId = event.currentTarget.id;
//       setName(flowId);

//       const response = await get(`apis/schematic_meter?total_flow=${flowId}`);
//       const data = response?.data?.data;

//       if (!data) {
//         setLoading(false);
//         return;
//       }

//      setUsage(data?.total_sum || "");
//      const meterFlow = data?.meter_flow || [];
//       console.log("meterFlow::", meterFlow);
//       const arryDatass = meterFlow.map((entry) => ({
//         name: entry?.option ?? "",
//         Flow: entry?.flow ?? 0,
//       }));

//       setNerge(arryDatass);
//       console.log("nerge", arryDatass);
//     } catch (error) {
//       console.error("Error fetching schematic meter data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   console.log("Nerge::", nerge);

//   const modalclick = (event) => {
//     setLoading(true);
//     setOpen(true);
//     var user = JSON.parse(localStorage.getItem("MCData"));
//     var userid = user?.userid;
//     console.log("object of scematics::", event.currentTarget);
//     const ApiResponse = async () => {
//       try {
//         const response = await get(
//           `apis/schematic_meter?meter_id=${event.currentTarget.id}&user_id=${userid}`
//         );
//         const mainRes = response.data;
//         console.log("Schematic response::", response.data);

//         setRes(mainRes.data);
//         setAccountname(mainRes.data?.overided_name);
//         setUsage(mainRes.data?.total_sum);
//         setMeterid(mainRes.data?.meter_id);
//         setStatus(mainRes.data?.status);
//         setAddress(mainRes.data?.location_address_line1);
//         setAddressone(mainRes.data?.location_address_line2);
//         setAddresstwo(mainRes.data?.location_city);
//         setAddressthree(mainRes.data?.location_state);
//         setAddressfour(mainRes.data?.location_zip);
//         setWeekly(mainRes.data?.meter_notification_active?.notification_status);
//         setregNo(mainRes.data?.register_number);
//         mainRes?.data?.meter_flow.map((x, i) => {
//           let Obj = {
//             name: x?.option,

//             Flow: x?.flow,
//           };

//           arryDatass.push(Obj);
//         });
//         setNerge(arryDatass);

//         console.log("nerge", nerge);

//         setLoading(false);
//       } catch (e) {
//         console.log("Error:", e);
//       }
//     };
//     ApiResponse();
//   };

//   console.log("Usage log::", meterid);

//   const handleCancel = () => {
//     setOpen(false);
//   };
//   const handleCancels = () => {
//     setOpens(false);
//   };
//   const handleCancelss = () => {
//     setOpenss(false);
//   };
//   const handleOk = () => {};
//   const onselectClickss = () => {
//     navigate("/schematics");
//   };
//   const onselectClick = () => {
//     navigate("/stats");
//   };
//   const onselectClicks = () => {
//     navigate("/devices");
//   };

//   console.log("res::", res);

//   return (
//     <>
//       {/* <head>
//         <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
//       <Header />
//       <Main className="bg-white">
//         <div>
//           <div className="d-flex align-items-center justify-content-between">
//             <div className="d-flex ">
//               <img
//                 src={back}
//                 alt=""
//                 style={{ width: "10px", cursor: "pointer" }}
//                 onClick={onRedirection}
//               />

//               <div className="d-flex align-items-center">
//                 <div
//                   className="new-box-padding  text-blue  align-self-center c-pointer "
//                   style={{
//                     borderBottom: "2px solid #1998f0",
//                     borderRadius: "0",
//                   }}
//                   onClick={onselectClickss}
//                 >

//                   Digital Twin{" "}
//                 </div>
//                 <div
//                   className=""
//                   style={{ width: "2px", height: "25px", background: "#ccc" }}
//                 ></div>
//                 <div
//                   className="new-box-padding   align-self-center c-pointer "
//                   style={{
//                     borderBottom: "2px solid #ccc",
//                   }}
//                   onClick={onselectClick}
//                 >

//                   Stats{" "}
//                 </div>
//                 <div
//                   className=""
//                   style={{ width: "2px", height: "25px", background: "#ccc" }}
//                 ></div>
//                 <div
//                   className="new-box-padding   align-self-center c-pointer "
//                   style={{
//                     borderBottom: "2px solid #ccc",
//                   }}
//                   onClick={onselectClicks}
//                 >

//                   Meters
//                 </div>
//               </div>
//             </div>

//           </div>
//           {openss === true ? (
//             <Modal
//               width={800}
//               title=""
//               open={openss}
//               onOk={handleOk}
//               onCancel={handleCancelss}
//               centered="true"
//               className="selectCheckbox"
//             >
//               {loading ? (
//                 <Spin />
//               ) : (
//                 <>
//                   <br />
//                   <div className="d-flex justify-content-between align-items-center  px-0">
//                     <div className="px-0 fs-4">

//                       <h5 className="text-blue mb-0">
//                         {name === "Produced"
//                           ? "Total Produced"
//                           : name === "NPS1"
//                           ? "114477/114476"
//                           : name === "NPS(P)"
//                           ? "Meter Usage"
//                           : name == "NPS(P1)"
//                           ? "Total Flow"
//                           : name == "NPS(P2)"
//                           ? "Total Flow"
//                           : "Status"}
//                       </h5>
//                       <p className="">[Last 30 Days]</p>
//                     </div>
//                     <div>
//                       <h5 className="mb-0 font-weight-100"> {usage} </h5>
//                       <p className="txt-gallonNew"> {unit}</p>
//                     </div>
//                   </div>
//                   <LineChart
//                     width={765}
//                     height={300}
//                     data={nerge}
//                     margin={{
//                       top: 5,
//                       right: 30,
//                       left: 20,
//                       bottom: 5,
//                     }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     {/* <Tooltip /> */}
//                     <Tooltip
//                       formatter={(value, name) => {
//                         if (name === "Flow") {
//                           return value.toLocaleString();
//                         }
//                         return value;
//                       }}
//                     />
//                     <Legend />
//                     <Line
//                       type="monotone"
//                       dataKey="Flow"
//                       stroke="#8884d8"
//                       activeDot={{ r: 8 }}
//                       strokeWidth={2}
//                     />
//                   </LineChart>
//                   <div className="labelYAxis5">Gallons</div>
//                   <div className="row">
//                     <div className="col-lg-6">
//                       <div className="text-black px-1 included-outliers bg-gray">
//                         Meter ID<div className="float-right">{meterid}</div>
//                       </div>
//                       <div className="row mt-2 fs-20 checkboxGreen">
//                         <div className="divnew">
//                           <h5 className="my-1">Status</h5>
//                           {Array.isArray(resTP?.data?.data?.data_meters) &&
//                           resTP.data.data.data_meters[0]?.status?.length ===
//                             0 ? (
//                             <span className="badge bg-success">Good</span>
//                           ) : (
//                             resTP?.data?.data?.data_meters?.[0]?.status?.map(
//                               (item, index) => {
//                                 const impact =
//                                   resTP.data.data.data_meters[0]?.impact ?? 0;

//                                 return (
//                                   <div key={index}>
//                                     {impact <= 0.2 ? (
//                                       <span className="yellownoti">{item}</span>
//                                     ) : impact <= 0.4 ? (
//                                       <span className="orangenoti">{item}</span>
//                                     ) : (
//                                       <span className="rednoti">{item}</span>
//                                     )}
//                                     <br />
//                                   </div>
//                                 );
//                               }
//                             )
//                           )}
//                         </div>
//                       </div>
//                       <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
//                         <div>Account Name </div>
//                         <div className="popupalignment"> {accountname}</div>
//                       </div>
//                       <div className="text-black px-1 included-outliers bg-gray">
//                         Location Address
//                       </div>
//                       <div>
//                         <div className="my-2 ">
//                           {address}
//                           <br />
//                           {addressone}
//                           <br />
//                           {addresstwo}
//                           <br />
//                           {addressthree}
//                           <br />
//                           {addressfour}
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-lg-6">
//                       <div className="text-black px-1 included-outliers bg-gray">
//                         Meter ID<div className="float-right">{meterids}</div>
//                       </div>
//                       <div className="row mt-2 fs-20 checkboxGreen">
//                         <div className="divnew">

//                           <h5 className="my-1">Status</h5>
//                           {Array.isArray(resTP?.data?.data?.data_meters) &&
//                           resTP.data.data.data_meters[1]?.status?.length ===
//                             0 ? (
//                             <span className="badge bg-success">Good</span>
//                           ) : (
//                             resTP?.data?.data?.data_meters?.[1]?.status?.map(
//                               (item, index) => {
//                                 const impact =
//                                   resTP.data.data.data_meters[1]?.impact ?? 0;

//                                 return (
//                                   <div key={index}>
//                                     {impact <= 0.2 ? (
//                                       <span className="yellownoti">{item}</span>
//                                     ) : impact <= 0.4 ? (
//                                       <span className="orangenoti">{item}</span>
//                                     ) : (
//                                       <span className="rednoti">{item}</span>
//                                     )}
//                                     <br />
//                                   </div>
//                                 );
//                               }
//                             )
//                           )}
//                         </div>
//                       </div>
//                       <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
//                         {" "}
//                         <div>Account Name</div>{" "}
//                         <div className="popupalignment"> {accountnames}</div>
//                       </div>
//                       <div className="text-black px-1 included-outliers bg-gray">
//                         Location Address
//                       </div>
//                       <div>
//                         <div className="my-2 ">
//                           {addresss}
//                           <br />
//                           {addressones}
//                           <br />
//                           {addresstwos}
//                           <br />
//                           {addressthrees}
//                           <br />
//                           {addressfours}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </Modal>
//           ) : (
//             ""
//           )}
//           {open === true ? (
//             <Modal
//               width={800}
//               title=""
//               open={open}
//               onOk={handleOk}
//               onCancel={handleCancel}
//               centered="true"
//               className="selectCheckbox"
//             >
//               {loading ? (
//                 <Spin />
//               ) : (
//                 <>
//                   <br />
//                   <div className="d-flex justify-content-between align-items-center  px-0">
//                     <div className="px-0 fs-4">

//                       <h5 className="text-blue mb-0"> Meter Usage </h5>
//                       <p className="">[Last 30 Days]</p>
//                     </div>
//                     <div>
//                       <h5 className="mb-0 font-weight-100 fs-6 fw-medium">
//                         {" "}
//                         {usage}{" "}
//                       </h5>
//                       <p className="txt-gallonNew"> {unit}</p>
//                     </div>
//                   </div>
//                   <LineChart
//                     width={765}
//                     height={300}
//                     data={nerge}
//                     margin={{
//                       top: 5,
//                       right: 30,
//                       left: 20,
//                       bottom: 5,
//                     }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />

//                     <Tooltip
//                       formatter={(value, name) => {
//                         if (name === "Flow") {
//                           return value.toLocaleString();
//                         }
//                         return value;
//                       }}
//                     />
//                     <Legend />
//                     <Line
//                       type="monotone"
//                       dataKey="Flow"
//                       stroke="#8884d8"
//                       activeDot={{ r: 8 }}
//                       strokeWidth={2}
//                     />
//                   </LineChart>
//                   <div className="labelYAxis5">Gallons</div>

//                   <div className="col text-black px-1 included-outliers bg-gray">
//                     Meter ID<div className="float-right">{meterid}</div>
//                     <br />
//                     <Checkbox
//                       id={meterid}
//                       onChange={weeklyChange}
//                       checked={weekly}
//                     >
//                       <p className="mb-0">
//                         <font>Add to alert</font>{" "}
//                       </p>
//                     </Checkbox>
//                   </div>

//                   <div className="row mt-2 fs-20 checkboxGreen">
//                     <div className="divnew">
//                       <h5 className="my-1 px-1">Status</h5>

//                       {Array.isArray(res?.status) &&
//                         res.status.map((item, index) => {
//                           let className = "";

//                           if (item === "Status is good") {
//                             className = "badge bg-success";
//                           } else if (res.impact <= 0.2) {
//                             className = "yellownoti";
//                           } else if (res.impact <= 0.4 && res.impact > 0.2) {
//                             className = "orangenoti";
//                           } else if (res.impact > 0.4) {
//                             className = "rednoti";
//                           }

//                           return (
//                             <React.Fragment key={index}>
//                               <span className={className}>{item}</span>
//                               <br />
//                             </React.Fragment>
//                           );
//                         })}
//                     </div>
//                   </div>
//                   <div className="text-black px-0 my-2 included-outliers bg-gray px-1">
//                     Account Name{" "}
//                     <div className="float-right popupalignment">
//                       {" "}
//                       <div>{accountname}</div>
//                     </div>
//                   </div>
//                   <div className="text-black px-0 included-outliers bg-gray px-1">
//                     Location Address
//                   </div>
//                   <div>
//                     <div className="my-2 px-1">
//                       {address}
//                       <br />
//                       {addressone}
//                       <br />
//                       {addresstwo}
//                       <br />
//                       {addressthree}
//                       <br />
//                       {addressfour}
//                     </div>
//                   </div>
//                 </>
//               )}
//             </Modal>
//           ) : (
//             ""
//           )}
//           {opens === true ? (
//             <Modal
//               width={800}
//               title=""
//               open={opens}
//               onOk={handleOk}
//               onCancel={handleCancels}
//               centered="true"
//               className="selectCheckbox"
//             >
//               {loading ? (
//                 <Spin />
//               ) : (
//                 <>
//                   <br />
//                   <div className="d-flex justify-content-between align-items-center  px-0">
//                     <div className="px-0 fs-4">
//                       <h5 className="text-blue mb-0">
//                         {" "}
//                         {name === "Potable_Demand"
//                           ? "Consumer Potable Meters"
//                           : name === "Potable_Supply"
//                           ? "Potable Supply"
//                           : name === "NPS(NP)"
//                           ? "Non Potable Supply"
//                           : "Consumer Non-Potable Meters"}
//                       </h5>
//                       <p className="">[Last 30 Days]</p>
//                     </div>
//                     <div>
//                       <h5 className="mb-0 font-weight-100"> {usage} </h5>
//                       <p className="txt-gallonNew"> {unit}</p>
//                     </div>
//                   </div>
//                   <LineChart
//                     width={765}
//                     height={300}
//                     data={nerge}
//                     margin={{
//                       top: 5,
//                       right: 30,
//                       left: 20,
//                       bottom: 5,
//                     }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     {/* <Tooltip /> */}
//                     <Tooltip
//                       formatter={(value, name) => {
//                         if (name === "Flow") {
//                           return value.toLocaleString();
//                         }
//                         return value;
//                       }}
//                     />
//                     <Legend />
//                     <Line
//                       type="monotone"
//                       dataKey="Flow"
//                       stroke="#8884d8"
//                       activeDot={{ r: 8 }}
//                       strokeWidth={2}
//                     />
//                   </LineChart>
//                   <div className="labelYAxis6">Gallons</div>
//                 </>
//               )}
//             </Modal>
//           ) : (
//             ""
//           )}
//           <div className="bottom-layout">
//             <div className="container-fluid pb-4 px-0 flex-column">
//               <div className="col-lg-12">
//                 <div id="wrapper">
//                   <div id="container">
//                     <ol className="organizational-chart">
//                       <li className="line-one">
//                         <div
//                           className="line-one-box-one"
//                           id="101893"
//                           onClick={modalclick}
//                         >
//                           <img src={Meter} className="img-fluid" />
//                           <span className="meter-value">101893</span>
//                         </div>
//                         <div className="arrow-first">
//                           <img
//                             src={LeftArrow}
//                             className="img-fluid img-rotate"
//                           />
//                         </div>
//                         <div className="line-one-box-two">
//                           <img src={Tank} className="img-fluid" />
//                           <span className="tank-name">Tank</span>
//                         </div>
//                         <div className="arrow-sec">
//                           <img
//                             src={LeftArrow}
//                             className="img-fluid tank-img-arrow"
//                           />
//                         </div>
//                         <div
//                           className="line-one-box-three"
//                           id="162902"
//                           onClick={modalclick}
//                         >
//                           <img src={Meter} className="img-fluid" />
//                           <span className="meter-value">162902</span>
//                         </div>
//                         <div className="line-one-box-four">
//                           <h1>COH</h1>
//                         </div>
//                         <div className="line-one-box-five">
//                           <img src={Reservoir} className="img-fluid" />
//                           <span class="tank-name2">Non Potable Reservoir </span>
//                         </div>
//                       </li>
//                       <li className="line-two">
//                         <div className="line-two-box-one">
//                           <img src={GPWell} className="img-fluid" />
//                           <span
//                             className="gp-name"
//                             style={{ width: "70%", left: "15%" }}
//                           >
//                             GP Well
//                           </span>
//                         </div>
//                         <div className="line-two-box-two">
//                           <div className="arrow-tank">
//                             <img
//                               src={LeftArrow}
//                               className="img-fluid tank-img-arrow"
//                             />
//                           </div>
//                           <img src={WaterPlants} className="img-fluid" />
//                           <p className="line-water-plants">Water Plant</p>
//                         </div>

//                         <div className="line-two-box-three">
//                           <div className="arrow-tank-water">
//                             <img
//                               src={LeftArrow}
//                               className="img-fluid tank-img-arrow"
//                             />
//                           </div>
//                           <img src={Pump} className="img-fluid" />
//                           <span className="gp-name">Non Potable Plant</span>
//                           <div className="arrow-tank-non-plant">
//                             <img
//                               src={LeftArrow}
//                               className="img-fluid tank-img-arrow"
//                             />
//                           </div>
//                         </div>

//                         <div className="arrow-line-right-onebox-five">
//                           <img
//                             src={LeftArrow}
//                             className="img-fluid tank-img-arrow"
//                           />
//                         </div>
//                       </li>
//                       <li className="line-three">
//                         <p style={{ visibility: "hidden" }}>
//                           North Distribution Meter
//                         </p>
//                         <div
//                           className="line-three-box-one"
//                           id="95434"
//                           onClick={modalclick}
//                         >
//                           <img src={Meter} className="img-fluid" />
//                           <span className="meter-value">95434</span>
//                           <p className="north-meter">
//                             North Distribution Meter
//                           </p>
//                         </div>
//                         <div
//                           className="line-three-box-two"
//                           id="Produced"
//                           onClick={modalclickss}
//                         >
//                           <div className="line-small-box-one produced-img">
//                             <img src={WaterMeter} className="img-fluid" />
//                           </div>
//                           <span className="">Total Produced</span>
//                         </div>
//                         <div
//                           className="line-three-box-one"
//                           id="126171"
//                           onClick={modalclick}
//                         >
//                           <img src={Meter} className="img-fluid" />
//                           <span className="meter-value">126171</span>
//                           <p className="south-meter">
//                             South Distribution Meter
//                           </p>
//                         </div>
//                         <p style={{ marginLeft: "15px", visibility: "hidden", width: '112px' }}>

//                         </p>
//                         <div
//                           className="line-three-box-three"

//                         >
//                           <div className="arrow-plant">
//                             <img
//                               src={LeftArrow}
//                               className="img-fluid img-rotate"
//                             />
//                           </div>

//                           <span
//                             id="NPS(P1)"

//                             onClick={modalclickss}
//                           >
//                             <img src={Meter} className="img-fluid" />
//                             <span className="meter-value">195026/195027</span>
//                             <br />
//                           </span>
//                         </div>
//                         <div
//                           className="line-three-box-four"

//                         >
//                           <img src={Meter} className="img-fluid" id="206680" onClick={modalclick}/>

//                           <span className="meter-value" id="206680" onClick={modalclick}>206680</span>
//                         </div>
//                       </li>
//                       <li className="line-four"></li>
//                       <li className="new-line-five">
//                         <div className="four-new-line">
//                           <div className="line-four-dflex">
//                             <p>IC</p>
//                             <div
//                               className="line-four-box-one"
//                               id="150850-L"
//                               onClick={modalclick}
//                             >
//                               <img src={Meter} className="img-fluid" />
//                               <span className="meter-value">150850</span>
//                               <div className="line-four-arrow-down" style={{transform: 'rotate(180deg)'}}>
//                                 <img
//                                   src={LeftArrow}
//                                   className="img-fluid tank-img-arrow"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="four-new-line box-two-align">
//                           <div className="line-four-dflex">
//                             <p>IC</p>
//                             <div
//                               className="line-four-box-one"
//                               id="150849-H"
//                               onClick={modalclick}
//                             >
//                               <img src={Meter} className="img-fluid" />
//                               <span className="meter-value">150849</span>
//                               <div className="line-four-arrow-down">
//                                 <img
//                                   src={LeftArrow}
//                                   className="img-fluid tank-img-arrow"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="four-new-line box-three-align">
//                           <div
//                             className="line-five-box-two"
//                             id="Potable_Supply"
//                             onClick={modalclicks}
//                           >
//                             <div className="line-small-box-one water-meter-img">
//                               <img src={WaterMeter} className="img-fluid" />
//                             </div>
//                             <span className="">Potable Supply</span>
//                           </div>
//                           <div
//                             className="line-five-box-two down-supply"
//                             id="Potable_Demand"
//                             onClick={modalclicks}
//                           >
//                             <div className="line-five-arrow-first-img">
//                               <img
//                                 src={LeftArrow}
//                                 className="img-fluid down-new-arrow"
//                               />
//                             </div>
//                             <div className="line-small-box-one water-meter-img">
//                               <img src={WaterMeter} className="img-fluid" />
//                             </div>
//                             <span className="">Consumer Potable Meters</span>
//                           </div>
//                         </div>
//                         <div className="meter-2025">
//                         <div
//                             className="meter-2025-box"

//                           >
//                             <img src={Meter} className="img-fluid"  id="NPS(P2)"
//                             onClick={modalclickss}/>
//                             <span className="meter-value"  id="NPS(P2)"
//                             onClick={modalclickss}>

//                               129122/129123
//                               </span>
//                           </div>

//                             <img
//                               src={LeftArrow}
//                               className="img-fluid img-rotate"
//                             />

//                         </div>

//                         <div className="d-flex align-items-baseline four-new-line-end">
//                           <div
//                             className="line-five-box-one"

//                             id="114476-H"

//                             onClick={modalclick}
//                           >
//                             <img src={Meter} className="img-fluid" />
//                             <span className="meter-value">114476</span>
//                           </div>
//                           <div className="line-five-box-two">
//                             <div className="line-small-box-one water-meter-img consumer-img">
//                               <img
//                                 src={WaterMeter}
//                                 className="img-fluid"
//                                 id="NPS(NP)"
//                                 onClick={modalclicks}
//                               />
//                             </div>
//                             <span
//                               className=""
//                               id="NPS(NP)"
//                               onClick={modalclicks}
//                             >
//                               Non Potable Supply
//                             </span>
//                             <div className="line-five-box-two down-supply">
//                               <div className="line-five-arrow-first-img">
//                                 <img
//                                   src={LeftArrow}
//                                   className="img-fluid down-new-arrow-sec"
//                                 />
//                               </div>
//                               <div className="line-small-box-one water-meter-img water-size-adjust">
//                                 <img
//                                   src={WaterMeter}
//                                   className="img-fluid"
//                                   id="Non_Potable_Demand"
//                                   onClick={modalclicks}
//                                 />
//                               </div>
//                               <span
//                                 className=""
//                                 id="Non_Potable_Demand"
//                                 onClick={modalclicks}
//                               >
//                                 Consumer Non-Potable Meters
//                               </span>
//                             </div>
//                           </div>

//                           <div
//                             className="line-five-box-one"

//                             id="114477-L"
//                             onClick={modalclick}
//                           >
//                             <img src={Meter} className="img-fluid" />
//                             <span className="meter-value">114477</span>
//                           </div>
//                         </div>
//                       </li>
//                     </ol>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Main>
//     </>
//   );
// };
// export default Schematics;

import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, { useState, useMemo, useCallback } from "react";
import { get, post } from "../Libraries/Ajax/HttpService";
import { Modal, Spin, Checkbox } from "antd";
import {
  ReactFlow,
  ReactFlowProvider,
  Background,
  Controls,
  Handle,
  Position,
} from "reactflow";
import dagre from "dagre";
import "reactflow/dist/style.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Meter from "../assets/images/meter.png";
import Tank from "../assets/images/tank.png";
import GPWell from "../assets/images/gpwell.png";
import WaterPlants from "../assets/images/water-plants.png";
import Pump from "../assets/images/pump.svg";
import Reservoir from "../assets/images/reservoir.svg";
import WaterMeter from "../assets/images/water-meter.png";
import { useDistrict } from "../utils/DistrictContext";
import {
  schematicJSON_Original,
  schematicJSON_District2,
  fixedPositions_Original,
  fixedPositions_District2,
} from "../utils/schematicData";
// ====================================================================
// 1. DATA AND ASSETS
// ====================================================================

const images = {
  meter: Meter,
  storage: Tank,
  source: GPWell,
  plant: WaterPlants,
  pump: Pump,
  reservoir: Reservoir,
  supply: WaterMeter,
  consumer: WaterMeter,
  process: WaterMeter,
};

const getLayoutedElements = (nodes, edges, direction = "TB", districtId) => {
  const g = new dagre.graphlib.Graph();
  g.setGraph({ rankdir: direction, nodesep: 300, ranksep: 380 });
  g.setDefaultEdgeLabel(() => ({}));

  nodes.forEach((n) => g.setNode(n.id, { width: 100, height: 80 }));
  edges.forEach((e) => g.setEdge(e.from, e.to));
  dagre.layout(g);

  // *** CONDITIONAL FIXED POSITIONS SELECTION ***
  const fixedPositions =
    districtId === "FB151" ? fixedPositions_District2 : fixedPositions_Original;

  const layoutedNodes = nodes.map((n) => {
    const pos = fixedPositions[n.id] || g.node(n.id);
    return {
      id: n.id,
      position: { x: pos.x, y: pos.y },
      data: { label: n.label, type: n.type, name: n.name },
      type: "customNode",
    };
  });

  //     const layoutedEdges = edges.map((e, i) => {
  //         const markerEndSetting = e.markerEnd === undefined
  //             ? { type: "arrowclosed", color: "#333" }
  //             : e.markerEnd;
  //     const isTargetEdge = (e.from === '206680' && e.to === 'non_potable_reservoir');

  //         // Set the type: 'default' for Bezier curve, 'smoothstep' for others
  //         const edgeType = isTargetEdge ? "default" : "smoothstep";

  //         // Define the style (making it slightly thicker for distinction)
  //         const edgeStyle = isTargetEdge
  //             ? {
  //                 stroke: "#333",      // Standard color
  //                 strokeWidth: 3,      // Slightly thicker
  //               }
  //             : {
  //                 stroke: "#333",
  //                 strokeWidth: 2
  //               }; // Standard style

  //         // Define source/target handles to force the R-L connection for the target edge
  //         const sourceHandle = isTargetEdge ? "right-source" : null;
  //         const targetHandle = isTargetEdge ? "left-target" : null;

  //         return {
  //             id: `e${i}`,
  //             source: e.from,
  //             target: e.to,
  //             animated: true,
  //             type: "smoothstep",
  //             style: { stroke: "#333", strokeWidth: 2 },
  //             markerEnd: markerEndSetting,
  //             sourceHandle: sourceHandle,
  //             targetHandle: targetHandle,
  //         };
  //     });
  //     return { layoutedNodes, layoutedEdges };
  // };

  const layoutedEdges = edges.map((e, i) => {
    const isSpecialEdge = e.from === "meter_150850" && e.to === "commonline7";
    const isNoArrowEdge = e.from === "meter_206680" && e.to === "commonline9";
    const isUpwardEdge = e.from === "commonline10" && e.to === "commonline7";
    const markerEndSetting =
      isSpecialEdge || isNoArrowEdge
        ? undefined // React Flow will skip rendering the marker
        : e.markerEnd === undefined
          ? { type: "arrowclosed", color: "#333" }
          : e.markerEnd;

    const isTargetEdge =
      e.from === "206680" && e.to === "non_potable_reservoir";

    // Set the type: 'default' for Bezier curve, 'smoothstep' for others
    const edgeType = isTargetEdge ? "default" : "smoothstep";

    // Define the style (making it slightly thicker for distinction)
    const edgeStyle = isTargetEdge
      ? {
          stroke: "#333", // Standard color
          strokeWidth: 3, // Slightly thicker
        }
      : {
          stroke: "#333",
          strokeWidth: 2,
        }; // Standard style

    // Define source/target handles to force the R-L connection for the target edge
    const sourceHandle = isTargetEdge ? "right-source" : null;
    const targetHandle = isTargetEdge ? "left-target" : null;

    return {
      id: `e${i}`,
      source: e.from,
      target: e.to,
      animated: true,
      type: edgeType, // FIX APPLIED: Used the calculated edgeType
      style: edgeStyle, // FIX APPLIED: Used the calculated edgeStyle
      markerEnd: markerEndSetting,
      // sourceHandle: sourceHandle,
      // targetHandle: targetHandle,
      sourceHandle: isUpwardEdge ? "source-top" : sourceHandle,
      targetHandle: isUpwardEdge ? "target-bottom" : targetHandle,
    };
  });
  return { layoutedNodes, layoutedEdges };
};
// ====================================================================
// 3. CUSTOM NODE COMPONENT
// ====================================================================

const CustomNode = ({ id, data }) => {
  const isPlant = data.type === "plant";
  const isNorthDistribution = id === "north_distribution_meter";
  const isSouthDistribution = id === "south_distribution_meter";
  const isICNode = id === "meter_150850" || id === "meter_150849";

  if (data.type === "structure") {
    return (
      <div
        style={{
          width: "1px",
          height: "1px",
          background: "transparent",
        }}
      >
        <Handle
          type="target"
          position={Position.Top}
          style={{ background: "#555", width: 8, height: 8 }}
        />
        <Handle
          type="target"
          position={Position.Left}
          id="left-target" // Unique ID is good practice
          style={{
            background: "#555",
            left: 0,
            transform: "translate(-50%, -50%)",
          }}
        />

        {/* Source Handle on the Right */}
        <Handle
          type="source"
          position={Position.Right}
          id="right-source" // Unique ID is good practice
          style={{
            background: "#555",
            right: 0,
            transform: "translate(50%, -50%)",
          }}
        />

        <Handle
          type="source"
          position={Position.Bottom}
          style={{ background: "#555", width: 8, height: 8 }}
        />
        <Handle
          type="target"
          position={Position.Top}
          id="target-top"
          style={{ opacity: 0 }}
        />
        <Handle
          type="target"
          position={Position.Bottom}
          id="target-bottom"
          style={{ opacity: 0 }}
        />

        {/* Source Handles (Outgoing) */}
        <Handle
          type="source"
          position={Position.Top}
          id="source-top"
          style={{ opacity: 0 }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          id="source-bottom"
          style={{ opacity: 0 }}
        />
      </div>
    );
  }

  const imageSize = (() => {
    switch (data.type) {
      case "meter":
        return 100;
      case "storage":
        return 120;
      case "plant":
        return 140;
      case "source":
        return 120;
      case "pump":
        return 90;
      case "reservoir":
        return 110;
      case "supply":
      case "consumer":
      case "process":
      case "label":
      case "structure":
        return 0;
      default:
        return 80;
    }
  })();

  const isCOHLabel = id === "coh";

  return (
    <div
      style={{
        textAlign: "center",
        cursor: ["meter", "consumer", "supply", "process"].includes(data.type)
          ? "pointer"
          : "default",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: "#555" }}
      />
      {images[data.type] && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            transform: isPlant ? "scale(1)" : "scale(1)",
            alignItems: "center",
          }}
        >
          <img
            src={images[data.type]}
            width={imageSize}
            alt=""
            style={{
              height: "auto",
              display: "block",
            }}
          />
        </div>
      )}

      <div
        style={
          isCOHLabel
            ? {
                fontSize: "18px",
                fontWeight: "bold",
                marginTop: "8px",
                background: "transparent",
                padding: "4px",
                borderRadius: "6px",
                width: "140px",
                boxShadow: "none",
                position: "relative",
              }
            : {
                fontSize: "20px",
                fontWeight: "bold",
                marginTop: data.type === "plant" ? "15px" : "8px",
                background: "#fff",
                padding: "4px 8px",
                borderRadius: "6px",
                width: "140px",
                textAlign: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                marginLeft: data.label === "Water Plant" ? "20px" : "0px",
              }
        }
      >
        <span
          style={{
            fontSize:
              data.type === "plant"
                ? "18px"
                : isCOHLabel
                  ? "24px"
                  : data.label.length > 8
                    ? "19px"
                    : "20px",
            fontWeight: "bold",
          }}
        >
          {data.label}
        </span>
      </div>
      {(isNorthDistribution || isSouthDistribution) && (
        <div
          style={{
            marginTop: "8px",
            backgroundColor: "#d9eaff",
            borderRadius: "4px",
            padding: "2px 6px",
            fontSize: "16px",
            fontWeight: "bold",
            width: "140px",
            textAlign: "center",
          }}
        >
          {isNorthDistribution
            ? "North Distribution Meter"
            : "South Distribution Meter"}
        </div>
      )}
      {isICNode && (
        <div
          style={{
            position: "absolute",
            left: "-60px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "#d9eaff",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          IC
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: "#555" }}
      />
    </div>
  );
};

// ====================================================================
// 4. MAIN COMPONENT (With Prop)
// ====================================================================

/**
 * Renders the water schematic for a given district.
 * @param {object} props
 * @param {'original' | 'district2'} props.districtId
 */
const Schematics = () => {
  // Step 1: Remove the districtId prop here
  const [isSingleModalOpen, setIsSingleModalOpen] = useState(false);
  const [singleMeterData, setSingleMeterData] = useState(null);
  const [isAlertEnabled, setIsAlertEnabled] = useState(false);
  const [regNo, setRegNo] = useState("");
  const [multiModalNodeType, setMultiModalNodeType] = useState(null);
  const [isMultiModalOpen, setIsMultiModalOpen] = useState(false);
  const [multiMeterData, setMultiMeterData] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); // Step 2: Use the value from the hook and assign it to 'districtId'

  const districtIdvalue = useDistrict();
  const districtIdnew = districtIdvalue?.selectedDistrict;
  const isFB151 = districtIdnew === "FB151";
  const navigate = useNavigate();
  const onRedirection = (event) => {
    navigate(-1);
  };
  const onselectClickss = () => {
    navigate("/schematics");
  };
  const onselectClick = () => {
    navigate("/stats");
  };
  const onselectClicks = () => {
    navigate("/devices");
  };

  const districtId = districtIdvalue?.selectedDistrict;
  const currentSchematicJSON =
    districtId === "FB151" ? schematicJSON_District2 : schematicJSON_Original;
  const minZoomValue = useMemo(() => {
    return districtId === "FB151" ? 0.5 : 0.4;
  }, [districtId]);

  const fitViewOptionsValue = useMemo(() => {
    if (districtId === "FB151") {
      return { padding: 0.05, includeHiddenNodes: true };
    }

    return { padding: 0.2, includeHiddenNodes: true };
  }, [districtId]);
  const multiApiNodeNames = useMemo(() => {
    if (districtId === "FB151") {
      return ["Total_Supply", "Total_Demand", "Tank"];
    }
    return ["Produced", "NPS(P1)", "NPS(P2)"];
  }, [districtId]);

  const { layoutedNodes, layoutedEdges } = useMemo(
    () =>
      getLayoutedElements(
        currentSchematicJSON.nodes,
        currentSchematicJSON.edges,
        "TB",
        districtId,
      ),
    // Dependency array updated to correctly re-calculate when data changes
    [districtId, currentSchematicJSON],
  );

  const nodeTypes = useMemo(() => ({ customNode: CustomNode }), []);

  const handleSingleMeterClick = useCallback(async (node) => {
    setLoading(true);
    setIsSingleModalOpen(true);
    setError(null);
    setSingleMeterData(null);
    let meterId = node?.data?.name?.trim() || "";

    let meter_id = node?.data?.name?.trim() || "";
    if (/^Well_\d+$/.test(meter_id)) {
      meter_id = meter_id.replace(/^Well_(\d+)$/, "Well #$1");
    }
    console.log("Meter ID before encoding:", meter_id); // should now be "Well #1"

    const encodedMeterId = encodeURIComponent(meter_id);
    console.log("Encoded Meter ID:", encodedMeterId); // should be "Well%20%231"

    // const meter_id = node.data.meterID;
    const user = JSON.parse(localStorage.getItem("MCData"));
    const userid = user?.userid;

    try {
      //  console.log("meterid",JSON.stringify(node));
      const response = await get(
        `apis/schematic_meter?meter_id=${encodedMeterId}&user_id=${userid}`,
      );
      const mainRes = response.data.data;
      setSingleMeterData(mainRes);
      setRegNo(mainRes?.register_number || "");
      setIsAlertEnabled(
      mainRes?.meter_notification_active?.notification_status || false,
      // mainRes?.status || false,
      );
    } catch (e) {
      console.error("Error fetching single meter data:", e);
      setError("Failed to load meter data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleMultiMeterClick = useCallback(async (node) => {
    setLoading(true);
    setIsMultiModalOpen(true);
    setError(null);
    setMultiMeterData(null);
    setModalTitle(node.data.label);
    setMultiModalNodeType(node.data.type);
    try {
      const response = await get(
        `apis/schematic_meter?total_flow=${node.data.name}`,
      );
      const resData = response?.data?.data;
      if (!resData) throw new Error("Invalid API response structure");

      setMultiMeterData({
        totalUsage: resData.total_sum || 0,
        unit: resData.unit || "Gallons",
        flowData:
          resData?.meter_flow?.map((x) => ({ name: x.option, Flow: x.flow })) ||
          [],
        meters: resData?.data_meters || [],
      });
    } catch (e) {
      console.error("Error fetching multi-meter data:", e);
      setError("Failed to load flow data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const onNodeClick = useCallback(
    (_, node) => {
      if (node.data.type === "storage" && node.id === "tank") return;
      const nodeName = node.data.name;
      if (multiApiNodeNames.includes(nodeName)) {
        handleMultiMeterClick(node);
      } else if (node.data.type === "meter" || node.data.type === "source") {
        handleSingleMeterClick(node);
      } else if (
        node.data.type === "storage" ||
        node.data.type === "consumer" ||
        node.data.type === "process" ||
        node.data.type === "supply"
      ) {
        handleMultiMeterClick(node);
      }
    },
    [handleSingleMeterClick, handleMultiMeterClick, multiApiNodeNames],
  );

  const handleSingleModalCancel = () => setIsSingleModalOpen(false);
  const handleMultiModalCancel = () => setIsMultiModalOpen(false);

  const handleAlertChange = (e) => {
    const isChecked = e.target.checked;
    setIsAlertEnabled(isChecked);
    const user = JSON.parse(localStorage.getItem("MCData"));
    const meter_id = e.target.id;
    post(
      `apis/notification_meters_update?user_id=${user?.userid}&meter_id=${meter_id}&account_name=${singleMeterData?.overided_name}&status=${isChecked}&register_number=${regNo}`,
    );
  };

  const StatusBadge = ({ status, impact }) => {
    if (!status || status.length === 0) {
      return <span className="badge bg-success">Good</span>;
    }
    return status.map((item, index) => {
      let className = "rednoti";
      if (item === "Status is good") {
        className = "badge bg-success";
      } else if (impact <= 0.2) className = "yellownoti";
      else if (impact <= 0.4) className = "orangenoti";
      return (
        <>
          <span key={index} className={className}>
            {item}
          </span>
                  <br />
        </>
      );
    });
  };

  return (
    <>
      <Header />
      <Main className="bg-white">
        {/* <div> */}
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex ">
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onRedirection}
            />

            <div className="d-flex align-items-center">
              <div
                className="new-box-padding  text-blue  align-self-center c-pointer "
                style={{
                  borderBottom: "2px solid #1998f0",
                  borderRadius: "0",
                }}
                onClick={onselectClickss}
              >
                Digital Twin{" "}
              </div>
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer "
                style={{
                  borderBottom: "2px solid #ccc",
                }}
                onClick={onselectClick}
              >
                Stats{" "}
              </div>
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer "
                style={{
                  borderBottom: "2px solid #ccc",
                }}
                onClick={onselectClicks}
              >
                Meters
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: "calc(100vh - 64px)",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          <ReactFlowProvider>
            <ReactFlow
              key={districtId}
              nodes={layoutedNodes}
              edges={layoutedEdges}
              nodeTypes={nodeTypes}
              fitView
              fitViewOptions={fitViewOptionsValue}
              minZoom={minZoomValue}
              maxZoom={1}
              onNodeClick={onNodeClick}
              proOptions={{ hideAttribution: true }}
            >
              <Background />
              <Controls
                showZoom={true}
                showInteractive={false}
                style={{
                  zIndex: 1000,
                  top: 10,
                  left: 10,
                  bottom: 1000,
                  pointerEvents: "none",
                }}
                className="custom-controls"
              />
            </ReactFlow>
          </ReactFlowProvider>

          {isSingleModalOpen && (
            <Modal
              width={800}
              open={isSingleModalOpen}
              onCancel={handleSingleModalCancel}
              footer={null}
              centered
            >
              {loading && (
                <div className="text-center p-5">
                  <Spin size="large" />
                </div>
              )}
              {error && (
                <div className="text-center p-5 text-danger">{error}</div>
              )}
              {!loading && !error && singleMeterData && (
                <>
                  <div className="d-flex justify-content-between align-items-center p-3">
                    <div>
                      <h5 className="text-blue mb-0">Meter Usage</h5>
                      <p className="mb-0">[Last 30 Days]</p>
                    </div>
                    <h5>{singleMeterData.total_sum?.toLocaleString()}</h5>
                  </div>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                      data={singleMeterData.meter_flow?.map((x) => ({
                        name: x.option,
                        Flow: x.flow,
                      }))}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis
                        label={{
                          value: "Gallons",
                          angle: -90,
                          position: "insideLeft",
                          dy: 30,
                          style: { textAnchor: "middle", fill: "#8884d8" },
                        }}
                      />
                      <Tooltip formatter={(value) => value.toLocaleString()} />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="Flow"
                        stroke="#8884d8"
                        activeDot={{ r: 8 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                  {!isFB151 ? (
                    <>
                      {" "}
                      <div className="p-3">
                        <div className="bg-light rounded d-flex justify-content-between align-items-center">
                          <span>
                            <strong>Meter ID:</strong>{" "}
                            {singleMeterData.meter_id}
                          </span>
                          <Checkbox
                            id={singleMeterData.meter_id}
                            onChange={handleAlertChange}
                            checked={isAlertEnabled}
                          >
                            Add to alert
                          </Checkbox>
                        </div>
                        <div className="mt-2">
                          <strong>Status:</strong>{" "}
                          <StatusBadge
                            status={singleMeterData.status}
                            impact={singleMeterData.impact}
                          />
                        </div>
                        <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
                          <div>Account Name </div>
                          <div className="popupalignment">
                            {" "}
                            {singleMeterData.overided_name}
                          </div>
                        </div>
                        <div
                          className="text-black px-0 included-outliers bg-gray"
                          style={{ position: "relative" }}
                        >
                          <span
                            style={{
                              position: "relative",
                              left: "-8px",
                              display: "inline-block",
                            }}
                          >
                            Location Address
                          </span>
                        </div>

                        <div>
                          <div>{singleMeterData?.location_address_line1}</div>
                          <div>{singleMeterData?.location_address_line2}</div>
                          <div>
                            {singleMeterData?.location_city},{" "}
                            {singleMeterData.location_state}{" "}
                            {singleMeterData.location_zip}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </Modal>
          )}

          {isMultiModalOpen && (
            <Modal
              width={800}
              open={isMultiModalOpen}
              onCancel={handleMultiModalCancel}
              footer={null}
              centered
            >
              {loading && (
                <div className="text-center p-5">
                  <Spin size="large" />
                </div>
              )}
              {error && (
                <div className="text-center p-5 text-danger">{error}</div>
              )}
              {!loading && !error && multiMeterData && (
                <>
                  <div className="d-flex justify-content-between align-items-center p-3">
                    <div>
                      {/* <h5 className="text-blue mb-0"> {multiModalNodeType === "meter" ? "Total Flow" : modalTitle}</h5> */}
                      <h5 className="text-blue mb-0">
                        {" "}
                        {multiModalNodeType === "meter"
                          ? "Total Flow"
                          : multiModalNodeType === "storage" && isFB151
                            ? "Tank Level"
                            : modalTitle}
                      </h5>
                      {/* <h5 className="text-blue mb-0">{modalTitle}</h5> */}

                      <p className="mb-0">[Last 30 Days]</p>
                    </div>
                    {isFB151 && multiModalNodeType === "storage" ? (
                      ""
                    ) : (
                      <h5>{multiMeterData.totalUsage?.toLocaleString()}</h5>
                    )}
                  </div>
                  <ResponsiveContainer width="100%" height={400}>
                    <LineChart data={multiMeterData.flowData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="name"
                        label={
                          isFB151 && multiModalNodeType === "storage"
                            ? {
                                value: "Level",
                                position: "insideBottom",
                                offset: -10,
                                style: {
                                  textAnchor: "middle",
                                  fill: "#8884d8",
                                },
                              }
                            : {
                                value: "Flow",
                                position: "insideBottom",
                                offset: -10,
                                style: {
                                  textAnchor: "middle",
                                  fill: "#8884d8",
                                },
                              }
                        }
                      />

                      <YAxis
                        label={{
                          // value: 'Gallons',
                          value:
                            isFB151 && multiModalNodeType === "storage"
                              ? "Feet"
                              : "Gallons",
                          angle: -90,
                          position: "insideLeft",
                          dy: 30,
                          style: { textAnchor: "middle", fill: "#8884d8" },
                        }}
                      />
                      <Tooltip formatter={(value) => value.toLocaleString()} />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="Flow"
                        name={
                          isFB151 && multiModalNodeType === "storage"
                            ? "Level"
                            : "Flow"
                        }
                        stroke="#8884d8"
                        activeDot={{ r: 8 }}
                      />
                    </LineChart>
                    {/* <div className="labelYAxis6">Gallons</div> */}
                  </ResponsiveContainer>

                  {["supply", "consumer", "process"].includes(
                    multiModalNodeType,
                  ) && (
                    <div className="row p-3">
                      {multiMeterData.meters.map((meter, index) => (
                        <div className="col-md-6" key={index}>
                          <div className="border rounded p-2 h-100">
                            <div className="bg-light  rounded">
                              <strong>Meter ID:</strong> {meter.meter_id}
                            </div>
                            <div className="mt-2">
                              <strong>Status:</strong>{" "}
                              <StatusBadge
                                status={meter.status}
                                impact={meter.impact}
                              />
                            </div>
                            <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
                              <div>Account Name </div>
                              <div className="popupalignment">
                                {" "}
                                {meter.overided_name}
                              </div>
                            </div>
                            <div
                              className="text-black px-0 included-outliers bg-gray"
                              style={{ position: "relative" }}
                            >
                              <span
                                style={{
                                  position: "relative",
                                  left: "-8px",
                                  display: "inline-block",
                                }}
                              >
                                Location Address
                              </span>
                            </div>

                            <div>
                              <div>{meter?.location_address_line1}</div>
                              <div>{meter?.location_address_line2}</div>
                              <div>
                                {meter.location_city}, {meter.location_state}{" "}
                                {meter.location_zip}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </Modal>
          )}
        </div>
      </Main>
    </>
  );
};

export default Schematics;
